import script from "./Root.vue?vue&type=script&setup=true&lang=ts"
export * from "./Root.vue?vue&type=script&setup=true&lang=ts"

import "./Root.vue?vue&type=style&index=0&id=071b180a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071b180a"]])

export default __exports__